// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"278":"065e49bc","591":"309034b0"}[chunkId] + ".chunk.css";
};